import { render, staticRenderFns } from "./CollectionRecordAddForm.vue?vue&type=template&id=585ea2eb&scoped=true"
import script from "./CollectionRecordAddForm.vue?vue&type=script&lang=js"
export * from "./CollectionRecordAddForm.vue?vue&type=script&lang=js"
import style0 from "./CollectionRecordAddForm.vue?vue&type=style&index=0&id=585ea2eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585ea2eb",
  null
  
)

export default component.exports